module.exports = __webpack_public_path__ + "static/media/bg5.9526daa1.jpg";